import React, { useState } from 'react';
import HeadingStatusComponent from '../../../components/AddListingsComponents/HeadingStatusComponent/HeadingStatusComponent';
import CreateListingComponent from '../../../components/AddListingsComponents/CreateListingComponent/CreateListingComponent';
import LocationComponent from '../../../components/AddListingsComponents/LocationComponent/LocationComponent';
import {
  ListingAmenitiesInitialValues,
  ListingDetailInitialValues,
  ListingLocationInitialValues,
  ListingNearByInitialValues,
} from '../../../utils/addListingInitialValue';
import DetailedInfoComponent from '../../../components/AddListingsComponents/DetailedInfoComponent/DetailedInfoComponent';
import AddMediaComponent from '../../../components/AddListingsComponents/AddMediaComponent/AddMediaComponent';
import NearByComponent from '../../../components/AddListingsComponents/NearByComponent/NearByComponent';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { resetProperty } from '../../../redux/slices/CreateLisingSlice';
import Loader from '../../../components/CommonComponents/Loader/Loader';
import { toastDefaults } from '../../../utils/ToastOptionCommon';
import axiosCall from '../../../utils/axiosCall';
import DashboardHeader from '../../../components/DashboardComponents/DashboardHeader/DashboardHeader';
import { ListingSection } from '../../../constants/ListingSection';
import NavigationPrompt from '../../../utils/NavigationPrompt/NavigationPrompt';
import { IoWarningOutline } from 'react-icons/io5';
import { setFormDirty } from '../../../redux/slices/LocationSlice';
import {
  approveProperty,
  approveSellProperty,
} from '../../../redux/slices/PropertySlice';
import { UnknownAction } from '@reduxjs/toolkit';
import Busy from '../../../assets/gif/busy.gif';
import { dealTypeEnum } from '../../../constants/Property';

function AddListings() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [propertyId, setPropertyId] = useState('');
  const [currentSection, setCurrentSection] = useState(ListingSection.Details);
  const [savedSection, setSavedSection] = useState<any>({
    [ListingSection.Details]: false,
    [ListingSection.Location]: false,
    [ListingSection.Amenities]: false,
    [ListingSection.NearBy]: false,
    // [ListingSection.Documents]: false,
  });
  const propertyState = useSelector((state: any) => state.property);
  const createListingState = useSelector((state: any) => state.createListing);

  const handleSubmit = async (formData: FormData) => {
    try {
      setIsLoading(true);
      formData.append(`propertyId`, propertyId);
      let response: any;
      console.log(propertyState);
      if (propertyId && currentSection === ListingSection.Details) {
        // Get the deal type from the form data
        const dealType = formData.get('dealType') || '';

        // Choose API endpoint based on deal type
        const baseUrl =
          dealType === dealTypeEnum.Sell ? '/sell-property' : '/properties';
        const url = `${baseUrl}/update/${propertyId}`;

        // edit request
        response = await axiosCall.put(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      } else {
        // Get the deal type from the form data
        const dealType =
          formData.get('dealType') || createListingState.dealType || '';

        // Choose API endpoint based on deal type
        const url =
          dealType === dealTypeEnum.Sell
            ? 'sell-property/create'
            : 'properties/create';

        response = await axiosCall.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      }
      const data = response.data;
      if (response.status === 201 || response.status === 200) {
        setSavedSection((prev: any) => ({ ...prev, [currentSection]: true }));
        if (currentSection === ListingSection.Documents) {
          // if (data?.subscription && !data.subscription.isActive) {
          //   toast.info('Please subscribe a package!', toastDefaults());
          //   navigate('/dashboard/Package');
          // } else {
          //   toast.success('Successfully Listed Property', toastDefaults());
          //   navigate('/dashboard/listing');
          // }
          // dispatch(resetProperty());
        } else {
          setCurrentSection(currentSection + 1);
        }
        dispatch(setFormDirty(false));
        setPropertyId(data?.updatedProperty?._id);
      } else if (response.status === 403) {
        dispatch(setFormDirty(true));
        toast.info(
          'You cannot make feature more properties under your current plan.',
          toastDefaults()
        );
      } else {
        dispatch(setFormDirty(true));
        toast.error('Failed to add property listing.', toastDefaults());
      }
    } catch (error: any) {
      dispatch(setFormDirty(true));
      console.error(`Add Listing error: ${error}`);
      if (error?.response?.status === 409) {
        toast.error('Property title already exist.', toastDefaults());
      }
      if (error?.response?.status === 403) {
        toast.info(error?.response?.data?.error, toastDefaults());
      } else {
        toast.error('Failed to add property listing.', toastDefaults());
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleApproveProperty = async () => {
    if (savedSection[ListingSection.Details] === false) {
      toast.info('Please fill property details.', toastDefaults());
      return;
    } else if (savedSection[ListingSection.Location] === false) {
      toast.info('Please fill location details.', toastDefaults());
      return;
    } else if (savedSection[ListingSection.Amenities] === false) {
      toast.info('Please add amenities.', toastDefaults());
      return;
    } else if (savedSection[ListingSection.NearBy] === false) {
      toast.info('Please add near by location.', toastDefaults());
      return;
    }

    let body = {
      isApproved: true,
      propertyId: propertyId,
    };

    setIsLoading(true);

    const resultAction = await dispatch(
      createListingState.dealType === dealTypeEnum.Sell
        ? (approveSellProperty({ body }) as unknown as UnknownAction)
        : (approveProperty({ body }) as unknown as UnknownAction)
    );

    // Choose the correct action reference
    const actionType =
      createListingState.dealType === dealTypeEnum.Sell
        ? approveSellProperty
        : approveProperty;

    if (actionType.fulfilled.match(resultAction)) {
      toast.success('Property is published successfully 🎉', {
        position: 'top-right',
        autoClose: 3000,
      });
      navigate('/dashboard/listing');
    } else if (actionType.rejected.match(resultAction)) {
      const err = resultAction.payload as any;
      if (err?.status === 403) {
        toast.info('Please subscribe a package!', toastDefaults());
        navigate('/dashboard/Package');
      } else if (err?.status === 400) {
        toast.info('Create property to publish!', toastDefaults());
        // setCurrentSection(ListingSection.Details);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        toast.error(err?.data?.error || 'Failed to publish property 🚨', {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    }
    setIsLoading(false);
  };

  return (
    <div id="createListingTab" className="main-content">
      {isLoading && <Loader />}

      <NavigationPrompt
        confirmationText={
          'Are you sure you want to leave without saving changes?'
        }
        icon={<IoWarningOutline className="m-1 warn-popup" />}
        saveButtonText={'Leave'}
        cancelButtonText={'Stay'}
        modalTitle={'Confirmation'}
        isProgress={false}
      />

      {/* Add property heading */}
      <DashboardHeader hideListingBtn={true} />
      <HeadingStatusComponent isEditListing={false} section={currentSection} />

      <div className="font-body">
        <CreateListingComponent
          handleSubmit={handleSubmit}
          currentSection={currentSection}
          setCurrentSection={setCurrentSection}
          initialValues={ListingDetailInitialValues}
          savedSection={savedSection}
        />
        {/* Location */}
        <LocationComponent
          dealType={createListingState.dealType || 'rent'}
          handleSubmit={handleSubmit}
          currentSection={currentSection}
          setCurrentSection={setCurrentSection}
          initialValues={ListingLocationInitialValues}
          savedSection={savedSection}
        />
        {/* Detailed Information */}
        <DetailedInfoComponent
          handleSubmit={handleSubmit}
          currentSection={currentSection}
          setCurrentSection={setCurrentSection}
          initialValues={ListingAmenitiesInitialValues}
          savedSection={savedSection}
        />
        {/* Near by */}
        <NearByComponent
          handleSubmit={handleSubmit}
          currentSection={currentSection}
          setCurrentSection={setCurrentSection}
          initialValues={ListingNearByInitialValues}
          savedSection={savedSection}
        />
        {/* Media & Submit */}
        <AddMediaComponent
          currentSection={currentSection}
          setCurrentSection={setCurrentSection}
          isEdit={false}
          setIsDocUpdate={null}
          handleSubmit={handleSubmit}
          savedSection={savedSection}
        />
        <div className="publish box-footer flex justify-end gap-3 text-center">
          <button
            type="submit"
            className="btn btn-primary"
            onClick={() => handleApproveProperty()}
            disabled={propertyState?.approvePropertyLoading}
          >
            {propertyState?.approvePropertyLoading && (
              <img
                src={Busy}
                alt="loading.."
                className="me-2 mb-1"
                style={{ maxWidth: '16px' }}
              />
            )}
            Publish
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddListings;
